module.exports = __webpack_public_path__ + "img/online-people-inquiry.17b86ecc.png";